import React from 'react';
import { useParams } from 'react-router-dom';
import posts from '../data/posts';
import Post from '../components/Post';

function PostDetail() {
  const { id } = useParams();
  const post = posts.find(p => p.id === Number(id));
  return (
    <main>
      <Post post={post} />
    </main>
  );
}

export default PostDetail;